export const ADD = "products/add";
export const INCREASE_QUANTITY = "products/increaseQuantity";
export const DECREASE_QUANTITY = "products/decreaseQuantity";
export const IS_PRODUCT_PAGE = "products/isProductPage";

